import { Component, Input, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { BorrowerValue } from 'app/models/dto/borrower-value.model';
import { Contact } from 'app/models/dto/contact.model';
import { BorrowerValueState } from 'app/store/borrower-value/borrower-value.state';
import { SendSignatureRequest } from 'app/store/contact/contact.actions';
import { ContactState } from 'app/store/contact/contact.state';
import { differenceInCalendarDays } from 'date-fns';
import { OwnerApplicationService } from 'ng2-app/modules/owner-application/models/owner-application.service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'app-signature-request-smart',
  templateUrl: './signature-request-smart.component.html',
  styleUrls: ['./signature-request-smart.component.scss'],
  standalone: false
})
export class SignatureRequestSmartComponent implements OnInit {

  @Select(ContactState.signatureRequestSending) signatureRequestSending$: Observable<{ sending: boolean, contactId: number | string }>;
  @Input() contact: Contact;

  signatureRequestSent = false;
  signatureStatus: string;
  signedDate: string;
  dateSigned$: Observable<BorrowerValue | null>;

  constructor(
    private store: Store,
    private ownerApplicationService: OwnerApplicationService
  ) {}

  ngOnInit(): void {
    this.signatureStatus = this.getSignatureStatus();
    this.dateSigned$ = this.store.select(BorrowerValueState.valueByAlias).pipe(map(filterFn => filterFn('date_signed')));
  }

  getSignatureStatus() {
    if (this.signatureRequestSent) {
      return 'Signature Request Sent';
    }

    const envelope = this.ownerApplicationService.getMostRecentEnvelope(this.contact);

    if (!envelope) {
      return 'Signature Request Not Sent';
    }

    if (!envelope.signed && !envelope.deleted) {
      return 'Signature Request Sent';
    }

    if (envelope.signed && this.daysAgo(envelope.signed) < 30 && !envelope.deleted) {
      this.signedDate = envelope.signed;
      return 'Application Signed';
    }

    return 'Signature Request Not Sent';
  }

  sendSignatureRequest() {
    this.store.dispatch(new SendSignatureRequest(this.contact)).pipe(take(1)).subscribe(() => {
      this.signatureStatus = this.getSignatureStatus();
    });
  }

  daysAgo(a: string): number {
    return differenceInCalendarDays(new Date(Date.now()), new Date(a));
  }
}
